<template>
  <v-container
    grid-list-md
  >
    <SensorCondition
      ref="condition"
      @search="conditionSearch"
    />
    <v-layout row>
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[10, 25, 50, 100]"
            item-key="serialNo"
            rows-per-page-text="1ページあたり"
            no-data-text="条件を設定し検索してください"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr @click="showDetail(item)">
                <td>
                  {{ item.serialNo }}
                </td>
                <td>
                  {{ item.sensorId }}
                </td>
                <td
                  class="text-xs-center"
                >
                  <v-switch
                    :input-value="item.installStatus"
                    :true-value="1"
                    :false-value="0"
                    readonly
                  />
                </td>
                <td
                  class="text-xs-center"
                >
                  <v-switch
                    :input-value="item.activateStatus"
                    :true-value="1"
                    :false-value="0"
                    readonly
                  />
                </td>
                <td>
                  {{ item.remarks }}
                </td>
              </tr>
            </template>
            <template
              v-if="loading"
              slot="no-data"
            >
              <tr>
                <div
                  style="height: 32px;"
                  class="my-3"
                />
                <v-progress-circular
                  class="loader"
                  indeterminate
                  color="metalBlue"
                  width="2"
                />
              </tr>
            </template>
          </v-data-table>
        </MaterialCard>
      </v-flex>
      <v-flex md4>
        <SensorDetail
          :sensor="selected"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SensorCondition, SensorDetail } from './components'
import { api } from '@/api'
import store from '@/store'

export default {
  components: {
    SensorCondition,
    SensorDetail
  },
  data: () => ({
    headers: [
      {
        sortable: true,
        text: 'シリアル',
        value: 'serialNo'
      },
      {
        sortable: true,
        text: '通信ID',
        value: 'sensorId'
      },
      {
        sortable: true,
        text: '取付',
        value: 'installStatus'
      },
      {
        sortable: false,
        text: 'アクティベート',
        value: 'activateStatus'
      },
      {
        sortable: false,
        text: '備考',
        value: 'remarks'
      }
    ],
    items: [],
    sensorTypes: [],
    selected: null,
    loading: false
  }),
  mounted () {
    this.conditionSearch({})
  },
  methods: {
    async conditionSearch (cond) {
      this.selected = null
      this.loading = true
      this.items = []

      const query = {}
      if (hasStringValue(cond.serialNo)) query.serialNo = cond.serialNo
      if (hasNumberValue(cond.assigned)) query.assigned = cond.assigned
      if (hasNumberValue(cond.installed)) query.installed = cond.installed

      try {
        const values = await this.querySearch(query)
        this.init(values)
      } catch {
        this.init({ sensors: [], sensorTypes: [] })
      } finally {
        this.loading = false
      }
    },
    init (values) {
      this.items = values.sensors
      this.sensorTypes = values.sensorTypes
    },
    async showDetail (item) {
      this.selected = item
    },
    async querySearch (query) {
      const response = await api.searchSensors({ groupId: store.state.groups.group.id, _with: 'sensor-type' })
      const assigned = getNumberValue(query.assigned)
      const installed = getNumberValue(query.installed)

      const sensors = response.sensors.filter(s => {
        if (query.serialNo != null && s.serialNo !== query.serialNo) {
          return false
        }
        if (assigned != null && s.assignStatus !== assigned) {
          return false
        }
        if (installed != null && s.installStatus !== installed) {
          return false
        }

        return true
      })
      return {
        sensors,
        sensorTypes: response.sensorTypes
      }
    }
  }
}

const hasStringValue = s => s != null && s !== ''
const hasNumberValue = n => n != null && n !== -1
const getNumberValue = s => {
  if (s == null) return null

  const n = parseInt(s, 10)
  if (isNaN(n)) return null
  if (n === -1) return null
  return n
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
